module.exports = __webpack_public_path__ + "img/bras_4kl.0f0ffacb.jpg";